import { useQuery } from 'react-query';
import { useFirebase } from 'components/Firebase/index.js';
import { useOrgId } from 'hooks/index.js';
import { vodUrl } from '../../../../../client-config.js';
import { ITEMS_PER_PAGE } from 'pages/Distributions/constants.js';

const useDistributionPagesQuery = ({ controlledBy, filterBy, search, page, pageSize = ITEMS_PER_PAGE, sortBy, sortOrder } = {}, options = {}) => {
  const firebase = useFirebase();
  const orgId = useOrgId();

  return useQuery({
    enabled: !!orgId,
    queryKey: ['distribution-pages', orgId, { filterBy, search, page, pageSize, sortBy, sortOrder }],
    queryFn: async () => {
      const idToken = await firebase.getIdToken();
      const offset = (page - 1) * pageSize;

      const fetchUrl = new URL(`${vodUrl}/v1/orgs/${orgId}/distribution-pages`);
      const urlParams = new URLSearchParams({
        ...(controlledBy && { controlledBy }),
        ...(search && { search }),
        ...(filterBy && { filterBy }),
        ...(offset && { offset }),
        ...(pageSize && { pageSize }),
        ...(sortBy && { sortBy }),
        ...(sortOrder && { sortOrder: sortOrder?.toUpperCase() }),
      });
      fetchUrl.search = urlParams.toString();

      const response = await fetch(fetchUrl.toString(), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${idToken}`,
        },
      });
      const { ok, status } = response;

      if (status === 404) return { data: [] };
      if (!ok) throw new Error(`Status: ${status}`);

      return response.json();
    },
    ...options,
  });
};

export default useDistributionPagesQuery;
